import { ActionButton, Spinner, SpinnerSize } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { EmailModel } from "../../models/EmailModel";
import { useCustomerEmailVM } from "../../viewmodels/CustomerEmailVM";
import EmailEntryView from "./EmailEntryView";
import EmailGridView from "./EmailGridView";

export default function CustomerEmailView() {
    const hasLoaded = useRef(false);
    const vm = useCustomerEmailVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const onDelete = (email: EmailModel) => {
        if (window.confirm(`Are you sure to delete email ${email.address}?`)) {
            vm.del(email.id);
        }
    }

    const onClose = () => {
        vm.setIsEdit(false);
        vm.setShowEntry(false);
        vm.resetForm();
    }

    const onSubmit = () => {
        if (vm.isEdit) {
            vm.edit();
        } else {
            vm.create();
        }
    }

    const refreshButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Refresh" }}
                onClick={vm.getList}
            >Refresh</ActionButton>
        </>;
    }

    const addButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Add" }}
                onClick={() => vm.setShowEntry(true)}
            >Add New</ActionButton>
        </>;
    }

    const headerView = () => {
        return <div className="ph-15 pv-10 container">
            <div className="font-title pr-10" style={{ marginBottom: 4 }}>Emails</div>
            {addButton()}
        </div>;
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <EmailGridView
                    emails={vm.emails}
                    key={vm.listHash}
                    onEdit={(email: EmailModel) => {
                        vm.setForm(email);
                        vm.setIsEdit(true);
                        vm.setShowEntry(true);
                    }}
                    onDelete={onDelete}
                />
            </div>
        </div>;
    }

    return <>
        {mainContent()}

        {vm.showEntry && <>
            <EmailEntryView
                isEdit={vm.isEdit}
                form={vm.form}
                errorMessages={vm.errorMessages}
                submitting={vm.submitting}
                onValueChange={vm.setField}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        </>}
    </>;
}